import React from 'react';
import { Link } from 'react-router-dom';
import { publicPath } from '../../utils/canonicalUrl';
import PublicSEO from '../../components/public/PublicSEO';
import './StatusPages.css';

const NotFoundPage = () => (
  <div className="vc-status-page">
    <PublicSEO
      title="Pagina non trovata"
      description="La pagina richiesta non e stata trovata."
      noIndex
    />
    <div className="container vc-status-page-inner">
      <p className="vc-status-code">404</p>
      <h1>Pagina non trovata</h1>
      <p>
        L'indirizzo potrebbe essere errato o la pagina potrebbe essere stata spostata. Puoi tornare alla home o
        consultare l'elenco dei medici disponibili.
      </p>
      <div className="vc-status-actions">
        <Link to="/" className="vc-btn vc-btn-primary">Torna alla home</Link>
        <Link to={publicPath('/medici')} className="vc-btn vc-btn-outline">Cerca un medico</Link>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
